import en from './common/en.json'
import nl from './common/nl.json'
import fr from './common/fr.json'

export default {
  en,
  nl,
  fr
}



// WEBPACK FOOTER //
// ./src/locale/index.js